import { createSlice } from "@reduxjs/toolkit";
import { getMediaUrl } from "../../utils/helpers";

const initialState = {
  status: "idle", // idle | outgoing | incoming | active | ended
  role: null, // caller | callee
  callId: null,
  startedAt: null,
  heartbeat_timer: null,
  isRatingOpen: false,
  remote: null,
};

const callSlice = createSlice({
  name: "call",
  initialState,
  reducers: {
    // ▶ YOU start a call
    startOutgoingCall(state, action) {
      const { callId, remote } = action.payload;

      state.status = "outgoing";
      state.role = "publisher";
      state.callId = callId;
      state.remote = remote;
    },

    // ☎ Someone calls you
    incomingCall(state, action) {
      const { callId, caller } = action.payload;

      state.status = "incoming";
      state.role = "publisher";
      state.callId = callId;

      state.remote = {
        userId: caller._id,
        name: caller.name,
        age: caller.age,
        profileImg: getMediaUrl(caller.ppImageURL),
        country: caller.countryId?.name,
        flag: caller.countryId?.flag,
      };
    },

    // ✅ Call accepted
    acceptCall(state, action) {

      const { startedAt, heartbeat_timer } = action.payload;
      state.startedAt = startedAt;
      state.heartbeat_timer = heartbeat_timer;
      state.status = "active";
    },

    // ✅ Call Active
    setCallActive(state) {
      state.status = "active";
    },

    openRating(state, action) {

      const { callId } = action.payload;
      return {
          ...initialState,
          callId,
          isRatingOpen: true,
        };
    },

    resetCallState() {
      return initialState;
    }
  },
});

export const {
  setCallActive,
  startOutgoingCall,
  incomingCall,
  acceptCall,
  openRating,
  resetCallState,
} = callSlice.actions;

export default callSlice.reducer;